// extracted by mini-css-extract-plugin
export default {"card":"qZ-z","carouselContainer":"rZ-z","carouselContent":"sZ-z"};